import { Interface } from '@ethersproject/abi';
import TOKENS_APPROVER_ABI from './tokens-approver.json';

const TOKENS_APPROVER_INTERFACE = new Interface(TOKENS_APPROVER_ABI);

export {
  // TOKENS_APPROVER_ABI,
  TOKENS_APPROVER_INTERFACE,
};
